import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetProjectsQuery } from "../../features/project/projectsApi";
import { useEditTaskMutation } from "../../features/task/taskApi";
import { useGetTeamsQuery } from "../../features/team/teamsApi";

export default function EditForm({ task }) {
  // edit task mutation
  const [editTask] = useEditTaskMutation();
  // get team members form rtq query
  const { data: teamMembers } = useGetTeamsQuery();
  // get projects
  const { data: projects } = useGetProjectsQuery();

  const [taskName, setTaskName] = useState(task.taskName);
  const [teamMemberId, setTeamMemberId] = useState(task.teamMember?.id);
  const [projectId, setProjectId] = useState(task.project?.id);
  const [deadline, setDeadline] = useState(task.deadline);

  const navigate = useNavigate();

  const handleUpdateTask = (e) => {
    e.preventDefault();
    const updatedTask = {
      id: task.id,
      taskName,
      teamMember: teamMembers.find(
        (member) => member.id === parseInt(teamMemberId)
      ),
      project: projects.find((project) => project.id === parseInt(projectId)),
      deadline,
    };

    editTask(updatedTask);
    navigate("/");
  };

  return (
    <>
      <form className="space-y-6" onSubmit={handleUpdateTask}>
        <div className="fieldContainer">
          <label for="lws-taskName">Task Name</label>
          <input
            type="text"
            name="taskName"
            id="lws-taskName"
            required
            placeholder="Implement RTK Query"
            value={taskName}
            onChange={(e) => setTaskName(e.target.value)}
          />
        </div>

        <div className="fieldContainer">
          <label>Assign To</label>
          <select
            name="teamMember"
            id="lws-teamMember"
            required
            onChange={(e) => setTeamMemberId(e.target.value)}
          >
            <option value="" hidden selected>
              Select Member
            </option>
            {teamMembers?.map((member) => (
              <option
                key={member.id}
                value={member.id}
                selected={member.id === task?.teamMember.id}
              >
                {member.name}
              </option>
            ))}
          </select>
        </div>
        <div className="fieldContainer">
          <label for="lws-projectName">Project Name</label>
          <select
            id="lws-projectName"
            name="projectName"
            required
            onChange={(e) => setProjectId(e.target.value)}
          >
            <option value="" hidden selected>
              Select Project
            </option>
            {projects?.map((project) => (
              <option
                key={project.id}
                value={project.id}
                selected={project.id === task?.project.id}
              >
                {project.projectName}
              </option>
            ))}
          </select>
        </div>

        <div className="fieldContainer">
          <label for="lws-deadline">Deadline</label>
          <input
            type="date"
            name="deadline"
            id="lws-deadline"
            required
            value={deadline}
            onChange={(e) => setDeadline(e.target.value)}
          />
        </div>

        <div className="text-right">
          <button type="submit" className="lws-submit">
            Update
          </button>
        </div>
      </form>
    </>
  );
}
